import { Link } from "react-router-dom";
import ArticleCard from "@/components/base/ArticleCard";
import { getRelatedArticles, type Article } from "@/mocks/articles";
import { getCategory } from "@/mocks/categories";

interface RelatedArticlesProps {
  article: Article;
}

export default function RelatedArticles({ article }: RelatedArticlesProps) {
  const related = getRelatedArticles(article, 3);
  const category = getCategory(article.category);

  return (
    <section id="related" className="scroll-mt-28 border-t border-background-200 pt-10">
      <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" />
            RELATED
          </span>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            相关大瓜推荐
          </h2>
        </div>
        {category && (
          <Link
            to={`/category/${category.slug}`}
            className="inline-flex w-fit items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700 cursor-pointer"
          >
            更多{category.name}
            <i className="ri-arrow-right-line" />
          </Link>
        )}
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {related.map((item) => (
          <ArticleCard key={item.id} article={item} variant="default" />
        ))}
      </div>
    </section>
  );
}